import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=2cee67d5&scoped=true&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=2cee67d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee67d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cee67d5')) {
      api.createRecord('2cee67d5', component.options)
    } else {
      api.reload('2cee67d5', component.options)
    }
    module.hot.accept("./ProfileTab.vue?vue&type=template&id=2cee67d5&scoped=true&", function () {
      api.rerender('2cee67d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/profile/views/ProfileView/components/ProfileTab.vue"
export default component.exports